import { render } from "./ObjectForm.vue?vue&type=template&id=5ee04b7c"
import script from "./ObjectForm.vue?vue&type=script&lang=js"
export * from "./ObjectForm.vue?vue&type=script&lang=js"

import "./ObjectForm.vue?vue&type=style&index=0&id=5ee04b7c&lang=css"
script.render = render

export default script